module.exports = __webpack_public_path__ + "static/media/handbags_getty_tablet.8eec0eba.jpg";